import { ReactComponent as UserQuestionStrokeStandard } from "../images/icons/user-question-02-stroke-standard.svg"
import { ReactComponent as DashboardSolid } from "../images/icons/dashboard-square-01-solid-standard.svg"
import { ReactComponent as SidebarLeftStroke } from "../images/icons/sidebar-left-01-stroke-standard.svg"
import { ReactComponent as ListSolid } from "../images/icons/left-to-right-list-dash-solid-standard.svg"
import { ReactComponent as UserMultipleSolid } from "../images/icons/user-multiple-02-solid-rounded.svg"
import { ReactComponent as UserQuestionSolid } from "../images/icons/user-question-01-solid-rounded.svg"
import { ReactComponent as CloudDownloadSolid } from "../images/icons/cloud-download-solid-rounded.svg"
import { ReactComponent as ViewOffSolidSharp } from "../images/icons/view-off-slash-solid-standard.svg"
import { ReactComponent as PasswordSolid } from "../images/icons/security-password-solid-standard.svg"
import { ReactComponent as StudentCardStroke } from "../images/icons/student-card-stroke-standard.svg"
import { ReactComponent as StudentCardSolid } from "../images/icons/student-card-solid-standard.svg"
import { ReactComponent as MailStrokeStandard } from "../images/icons/mail-02-stroke-standard.svg"
import { ReactComponent as ArrowDownSharp } from "../images/icons/arrow-down-01-stroke-sharp.svg"
import { ReactComponent as DeleteStroke } from "../images/icons/delete-03-stroke-standard.svg"
import { ReactComponent as AlertStroke } from "../images/icons/alert-02-stroke-standard.svg"
import { ReactComponent as DeleteSolid } from "../images/icons/delete-03-solid-standard.svg"
import { ReactComponent as CancelSolid } from "../images/icons/cancel-01-solid-standard.svg"
import { ReactComponent as ChatStrokeRounded } from "../images/icons/chat-stroke-rounded.svg"
import { ReactComponent as UploadSolid } from "../images/icons/upload-02-solid-standard.svg"
import { ReactComponent as LicenseSolid } from "../images/icons/license-solid-standard.svg"
import { ReactComponent as ImageSolid } from "../images/icons/image-03-solid-standard.svg"
import { ReactComponent as EditStroke } from "../images/icons/edit-04-stroke-rounded.svg"
import { ReactComponent as PlusSolid } from "../images/icons/plus-sign-solid-rounded.svg"
import { ReactComponent as EditSolid } from "../images/icons/edit-04-solid-standard.svg"
import { ReactComponent as MailSolid } from "../images/icons/mail-02-solid-standard.svg"
import { ReactComponent as ForumAll } from "../images/icons/file-01-solid-standard.svg"
import { ReactComponent as ViewSolidSharp } from "../images/icons/view-solid-sharp.svg"
import { ReactComponent as Menu } from "../images/icons/menu-11-stroke-rounded.svg"

const Icons = {
  UserQuestionStrokeStandard,
  CloudDownloadSolid,
  MailStrokeStandard,
  SidebarLeftStroke,
  ChatStrokeRounded,
  UserMultipleSolid,
  UserQuestionSolid,
  StudentCardStroke,
  ViewOffSolidSharp,
  StudentCardSolid,
  ArrowDownSharp,
  DashboardSolid,
  ViewSolidSharp,
  PasswordSolid,
  DeleteStroke,
  LicenseSolid,
  AlertStroke,
  DeleteSolid,
  CancelSolid,
  UploadSolid,
  EditStroke,
  ImageSolid,
  EditSolid,
  ListSolid,
  MailSolid,
  PlusSolid,
  ForumAll,
  Menu,
}

export default Icons